// extracted by mini-css-extract-plugin
export default {"page":"ConfigurationPage_page__n67q9","container":"ConfigurationPage_container__xXTt0","description":"ConfigurationPage_description__r3FHx","btn":"ConfigurationPage_btn__E7Jzp"};